import CourseList from "./CourseList";
import StudentOrderList from "./StudentOrderList";
import { useCallback, useEffect, useState } from "react";
import api from "common/api";
import { IOrder, OrderInfo } from "common/types";
import { toast } from "react-toastify";
import StudentPaidOrdersList from "./StudentPaidOrdersList";

function StudentDashboard() {
  const [orders, setOrders] = useState<IOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get<IOrder[]>("/orders/");
      setOrders(response.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error(
        "Došlo je do greške prilikom dohvaćanja narudžbi. Pokušajte ponovo kasnije.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const ordersByCreatedAtDesc = [...orders].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );

  const unpaidOrders = ordersByCreatedAtDesc.filter(
    (order) => !order.paid && order.info === OrderInfo.PREPARATIONS,
  );
  const paidOrders = ordersByCreatedAtDesc.filter(
    (order) => order.paid && order.info === OrderInfo.PREPARATIONS,
  );

  return (
    <div>
      <StudentOrderList unpaidOrders={unpaidOrders} loading={loading} />
      <CourseList />
      <StudentPaidOrdersList orders={paidOrders} loading={loading} />
    </div>
  );
}

export default StudentDashboard;
